
export class SimpleDataFilter {
    constructor(key:string,value:string,transient : boolean = false, nullCheck : boolean = false, comparer : string = 'like', filterType : FilterDataType = FilterDataType.StringData){
        this.key = key;
        this.value = value;
        this.isTransient = transient;
        this.performNullCheck = nullCheck;
        this.comparer = comparer;
        this.dataType = filterType;
    }
    key: string;
    value: string;
    isTransient : boolean;
    performNullCheck : boolean;
    // SHould be AND/OR
    conditionalOperator :string = 'AND';
    isNotNull : boolean = false;

    // like,= etc
    comparer : string;
    dataType : FilterDataType;
}

export enum FilterDataType {
    StringData = 0,
    Number,
    Date
}